/* SWEEPAW — Carte d'achat flottante (MISSION R-STICKY-ATC / R-STICKY-FIX).
   Asset externe (plutôt qu'un <script> inline dans la section) pour une
   exécution fiable, hot-reload compris. Le bouton soumet le MÊME
   formulaire que le bouton principal via l'attribut form= (pas de
   <form> dupliqué). Init idempotente, tolérante à tout ordre de DOM.

   Résilience au remplacement de section (Theme Editor / hot-reload) :
   quand une section est re-rendue, Shopify remplace son sous-arbre DOM
   et émet shopify:section:unload puis shopify:section:load sur la
   nouvelle racine. Les IntersectionObserver attachés aux anciens noeuds
   deviennent alors orphelins (ils n'observent plus rien de visible à
   l'écran) : on les déconnecte sur :unload et on réinitialise sur
   :load, qui cible forcément un nouveau noeud sans dataset.stickyInit. */
(function () {
  function initStickyATC(bar) {
    if (bar.dataset.stickyInit) return;
    bar.dataset.stickyInit = '1';

    var cleanupFns = [];
    bar._stickyCleanup = function () {
      cleanupFns.forEach(function (fn) { fn(); });
    };

    var sectionId = bar.dataset.sectionId;
    var mainButton = document.getElementById('ProductSubmitButton-' + sectionId);
    if (!mainButton) return;

    var offer = document.getElementById('SweepawOffer-' + sectionId);
    var subscribeInput = document.getElementById('SweepawSubscribe-' + sectionId);
    var stickyPrice = document.getElementById('SweepawStickyPrice-' + sectionId);
    var stickyPriceMobile = document.getElementById('SweepawStickyPriceMobile-' + sectionId);
    var stickyButton = document.getElementById('SweepawStickySubmit-' + sectionId);

    function getCurrentPriceText() {
      if (!offer) return '';
      var checkedRadio = offer.querySelector('input[name="sweepaw-tier"]:checked');
      if (!checkedRadio) return '';
      var row = checkedRadio.closest('.sweepaw-offer__row');
      if (!row) return '';
      var subscribePrice = row.querySelector('.sweepaw-offer__price--subscribe');
      if (subscribePrice && getComputedStyle(subscribePrice).display !== 'none') {
        return subscribePrice.textContent.trim();
      }
      var onetimePrice = row.querySelector('.sweepaw-offer__price--onetime') || row.querySelector('.sweepaw-offer__price');
      return onetimePrice ? onetimePrice.textContent.trim() : '';
    }

    function syncStickyPrice() {
      var priceText = getCurrentPriceText();
      if (!priceText) return;
      if (stickyPrice) stickyPrice.textContent = priceText;
      if (stickyPriceMobile) stickyPriceMobile.textContent = priceText;
    }

    if (offer) offer.addEventListener('change', syncStickyPrice);
    if (subscribeInput) subscribeInput.addEventListener('change', syncStickyPrice);
    syncStickyPrice();

    var mainButtonVisible = true;
    var footerVisible = false;

    function updateStickyVisibility() {
      var shouldShow = !mainButtonVisible && !footerVisible;
      if (shouldShow) {
        bar.classList.add('is-visible');
        bar.setAttribute('aria-hidden', 'false');
        document.body.classList.add('has-sweepaw-sticky-atc');
      } else {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('has-sweepaw-sticky-atc');
      }
    }

    var mainButtonObserver = new IntersectionObserver(function (entries) {
      mainButtonVisible = entries[0].isIntersecting;
      updateStickyVisibility();
    }, { threshold: 0 });
    mainButtonObserver.observe(mainButton);
    cleanupFns.push(function () { mainButtonObserver.disconnect(); });

    var footerEl = document.querySelector('footer');
    if (footerEl) {
      var footerObserver = new IntersectionObserver(function (entries) {
        footerVisible = entries[0].isIntersecting;
        updateStickyVisibility();
      }, { threshold: 0 });
      footerObserver.observe(footerEl);
      cleanupFns.push(function () { footerObserver.disconnect(); });
    }

    if (stickyButton) {
      var mirrorButtonState = function () {
        var isLoading = mainButton.classList.contains('loading');
        var isDisabled = mainButton.getAttribute('aria-disabled') === 'true';
        stickyButton.classList.toggle('loading', isLoading);
        if (isDisabled) {
          stickyButton.setAttribute('aria-disabled', 'true');
        } else {
          stickyButton.removeAttribute('aria-disabled');
        }
      };
      var buttonObserver = new MutationObserver(mirrorButtonState);
      buttonObserver.observe(mainButton, { attributes: true, attributeFilter: ['class', 'aria-disabled'] });
      cleanupFns.push(function () { buttonObserver.disconnect(); });

      var stickyClickGuard = function (event) {
        if (mainButton.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
        }
      };
      stickyButton.addEventListener('click', stickyClickGuard);
      cleanupFns.push(function () { stickyButton.removeEventListener('click', stickyClickGuard); });
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('.sweepaw-sticky-atc[data-section-id]').forEach(initStickyATC);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  }

  document.addEventListener('shopify:section:unload', function (event) {
    var bar = event.target.querySelector && event.target.querySelector('.sweepaw-sticky-atc[data-section-id]');
    if (bar && bar._stickyCleanup) bar._stickyCleanup();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
